// Randomize testimonial cards order on each load
function initTestimonialsShuffle() {
  const lists = document.querySelectorAll('[data-testimonials-random]');
  if (!lists.length) return;

  lists.forEach(list => {
    const items = Array.from(list.children);
    if (items.length < 2) return;

    const shuffled = items
      .map(node => ({ node, order: Math.random() }))
      .sort((a, b) => a.order - b.order)
      .map(entry => entry.node);

    shuffled.forEach(node => list.appendChild(node));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTestimonialsShuffle);
} else {
  initTestimonialsShuffle();
}
